export default function SkeletonBankDetails() {
  return (
    <div className="mt-5 animate-pulse container px-4 md:px-0 lg:w-[85%] mx-auto">
      {/* Top Image Section */}
      <div className="relative w-full h-75 md:h-112.5 lg:h-137.5 overflow-hidden rounded-xl">
        <div className="w-full h-full bg-gray-300"></div>

        <div className="absolute top-0 left-0 z-50 p-5 sm:p-10">
          <div className="w-30 h-30 bg-gray-300 rounded-md mt-10"></div>

          <div className="mt-5 space-y-3">
            <div className="h-6 w-40 bg-gray-300 rounded"></div>
            <div className="h-6 w-32 bg-gray-300 rounded"></div>
          </div>
        </div>
      </div>

      {/* Text Section */}
      <div className="mt-8 space-y-14 pb-20">
        {/* Bank Name + Description */}
        <div>
          <div className="h-7 w-52 bg-gray-300 rounded mb-4"></div>

          <div className="space-y-3">
            <div className="h-4 w-full bg-gray-300 rounded"></div>
            <div className="h-4 w-5/6 bg-gray-300 rounded"></div>
            <div className="h-4 w-4/6 bg-gray-300 rounded"></div>
          </div>
        </div>

        {/* Documents Section */}
        <div>
          <div className="h-7 w-60 bg-gray-300 rounded mb-4"></div>

          <div className="space-y-4 mt-4">
            {Array.from({ length: 5 }).map((_, i) => (
              <div key={i} className="flex items-center gap-2">
                <div className="h-4 w-4 bg-gray-300 rounded"></div>
                <div className="h-4 w-2/3 bg-gray-300 rounded"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export const BlogSkeleton = () => {
  return (
    <div className="flex flex-col lg:flex-row lg:items-center gap-5 animate-pulse">
      {/* Image Skeleton */}
      <div className="relative w-80 h-80 bg-gray-300 rounded-lg"></div>

      {/* Content Skeleton */}
      <div className="lg:w-1/2 flex flex-col gap-4">
        {/* Title Skeleton */}
        <div className="h-6 bg-gray-300 rounded w-3/4"></div>

        {/* Description Skeleton */}
        <div className="space-y-2">
          <div className="h-4 bg-gray-200 rounded w-full"></div>
          <div className="h-4 bg-gray-200 rounded w-5/6"></div>
          <div className="h-4 bg-gray-200 rounded w-4/6"></div>
        </div>

        {/* Button Skeleton */}
        <div className="flex justify-end mt-2">
          <div className="h-10 w-24 bg-gray-300 rounded"></div>
        </div>
      </div>
    </div>
  );
};

export function BlogDetailSkeleton() {
  return (
    <div className="animate-pulse">
      {/* IMAGE SKELETON */}
      <div className="flex justify-center max-h-150 overflow-hidden rounded-lg">
        <div className="w-full max-w-200 h-100 bg-gray-300 rounded-lg" />
      </div>

      {/* TEXT CONTENT */}
      <div className="mt-8 prose prose-lg max-w-none space-y-5">
        {/* TITLE */}
        <div className="space-y-3">
          <div className="h-8 bg-gray-300 rounded w-3/4"></div>
          <div className="h-4 bg-gray-300 rounded w-1/2"></div>
        </div>

        {/* DESCRIPTION */}
        <div className="space-y-3">
          <div className="h-4 bg-gray-300 rounded w-full"></div>
          <div className="h-4 bg-gray-300 rounded w-5/6"></div>
        </div>

        {/* CONTENT */}
        <div className="space-y-3">
          <div className="h-4 bg-gray-300 rounded w-full"></div>
          <div className="h-4 bg-gray-300 rounded w-11/12"></div>
          <div className="h-4 bg-gray-300 rounded w-10/12"></div>
        </div>
      </div>
    </div>
  );
}
